import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { ConfirmationDialogProps } from 'features/ConfirmationDialog/ConfirmationDialog'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'
import { UIActions } from 'store/UI/UIActions'
import { newProjectActions } from '../newProjectReducer'
import { bomItemSelector } from '../selectors/bomItemSelector'
import { projectSelectors } from '../selectors/projectSelectors'
import i18n from 'i18next'
import { fetchProject } from './fetchProject'

export const saveBomItemIsPurchasingPart = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'boM/saveBomItemIsPurchasingPart',
  async ({ bomItemId }: { bomItemId?: string }, thunkAPI) => {
    // let setAsPurchasing = false

    const updateLocalState = (itemId: string) => {
      const bomItem = bomItemSelector(thunkAPI.getState(), itemId)

      if (bomItem.type !== 'Row' && bomItem.type !== 'Assembly') {
        throw Error(
          'only partTypes or sub assemblies can be set as purchasing part'
        )
      }

      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: itemId,
          isPurchasingBomItem: !bomItem.isPurchasingBomItem ?? true,
        })
      )

      // setAsPurchasing = !bomItem.isPurchasingBomItem
    }

    const updateServer = async (bomItemId: string) => {
      const { partyId: organizationId, projectId } = getContext(
        thunkAPI.getState
      )

      const controller = new BomItemController(organizationId, projectId)

      const bomItem = bomItemSelector(thunkAPI.getState(), bomItemId)

      switch (bomItem.type) {
        case 'Row':
          try {
            if (!bomItem.isPurchasingBomItem) {
              return await controller.UnsetAsPurchasingItem([bomItemId])
            } else {
              return await controller.SetAsPurchasingItem([bomItemId])
            }
          } catch (err) {
            thunkAPI.dispatch(fetchProject({ projectId: projectId }))
            throw err
          }
        case 'Assembly':
          thunkAPI.dispatch(
            UIActions.OpenModal('ConfirmationDialog', {
              title: i18n.t(
                'project:convert-to-purchasing-part',
                'purchasing part'
              ),
              onConfirm: async () => {
                try {
                  return await controller.ConvertSubAssemblyToPurchasingPart(
                    bomItemId
                  )
                } catch (err) {
                  thunkAPI.dispatch(fetchProject({ projectId: projectId }))
                  ShowException(
                    i18n.t('project:convert-to-purchasing-part'),
                    err
                  )
                  throw err
                }
              },
              onCancel: () => {
                thunkAPI.dispatch(fetchProject({ projectId: projectId }))
              },
            } as ConfirmationDialogProps)
          )

          return Promise.resolve()
          break
        default:
          throw Error(`${bomItem.type} can't be set as purchasing part`)
      }
    }

    try {
      const bomItemIds = bomItemId
        ? [bomItemId]
        : projectSelectors
            .selectedBomItemsSelector(thunkAPI.getState())
            .map((x) => x.id)

      if (!bomItemIds.length) {
        console.error('no bom item to set as purchasing parts')
        return
      }

      bomItemIds.forEach(updateLocalState)
      bomItemIds.forEach(updateServer)

      if (bomItemIds.length > 1) {
        thunkAPI.dispatch(newProjectActions.clearSelectedBomItems())
      }
    } catch (err) {
      ShowException('project', err)
      throw err
    }
  }
)
